<div [formGroup]="formGroup">
  <div class="form-group">
    <label title="The subject line of the email">Subject</label>
    <input type="text" class="form-control" formControlName="subject" />
    @if (showError('subject', 'required')) {
      <p class="error">Required</p>
    }
  </div>

  <div class="form-group">
    <label title="This is the email body template">HTML Body</label>
    <app-html-editor [extendedToolbar]="extendedToolbar" height="425px" formControlName="body" caption="" [macros]="macros"></app-html-editor>
    @if (showError('body', 'required')) {
      <p class="error">Required</p>
    }
  </div>
</div>